/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ListSuppliers$Params {
  VenueId?: string;
  StartDate?: string;
  EndDate?: string;
}

export function listSuppliers(http: HttpClient, rootUrl: string, params?: ListSuppliers$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, listSuppliers.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
    rb.query('StartDate', params.StartDate, {});
    rb.query('EndDate', params.EndDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

listSuppliers.PATH = '/api/mng/Supply/listsuppliers';
